<div class="mt-10">
  <div class="mb-4 flex items-center justify-between">
    <h3 class="text-sm font-bold text-gray-700">
      <span i18n="@@stock.list.readyToSubmit">{{ list().length }} items ready to submit</span>
    </h3>
  </div>

  <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
    <table class="w-full min-w-[1200px] border-collapse ltr:text-left rtl:text-right">
      <thead class="bg-surface-subtle border-b border-gray-200">
        <tr>
          <th class="w-12 px-4 py-3 text-center text-[12px] font-bold text-gray-500">#</th>
          <th class="px-4 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.table.product">
            Product
          </th>
          <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colMfgExp">
            MFG / Expiry Date
          </th>
          <th class="px-4 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.table.batch">
            Batch No.
          </th>
          <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colPeoplePrice">
            People Price
          </th>
          <th class="px-4 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Seller">
            Seller Price & Discount
          </th>
          <th class="px-4 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Pharmacy">
            Pharmacy Price & Discount
          </th>
          <th class="px-4 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.table.qty">Quantity</th>
          <th class="px-6 py-4 text-center text-[12px] font-bold text-gray-500 uppercase"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100">
        @for (item of list(); track item.id; let i = $index) {
          <tr class="transition-colors hover:bg-gray-50">
            <td class="px-4 py-4 text-center text-[12px] font-medium text-gray-500">{{ i + 1 }}</td>
            <td class="px-4 py-4 text-center">
              <div class="text-[12px] font-bold text-gray-800">{{ item.productTitle }}</div>
            </td>
            <td class="px-3 py-4 text-center">
              <div class="flex flex-col items-center text-[11px] leading-tight font-bold tabular-nums">
                <span class="text-green-600">{{ mfgLabel() }} {{ item.mfgDate | date: "MM/yyyy" }}</span>
                <span
                  [ngClass]="{
                    'text-red-600': isExpired(item.expDate),
                    'text-orange-500': isNearExpiry(item.expDate),
                  }">
                  {{ expLabel() }} {{ item.expDate | date: "MM/yyyy" }}
                </span>
              </div>
            </td>
            <td class="px-4 py-4 text-center text-[12px] text-gray-600">{{ item.batchNumber }}</td>
            <td class="px-3 py-4 text-center font-bold text-gray-800">
              {{ item.peoplePrice }}
              <span class="text-[10px] font-medium">{{ currency() }}</span>
            </td>

            <td class="px-4 py-4 text-center text-[13px]">
              <div class="font-bold">
                {{
                  item.peoplePrice - (item.peoplePrice * (item.sellerPriceDiscountPercentage || 0)) / 100
                    | number: "1.2-2"
                }}
                {{ currency() }}
              </div>
              @if (item.sellerPriceDiscountPercentage) {
                <div class="text-[10px] font-bold text-red-500">
                  {{ isArabic() ? "خصم" : "Disc." }} {{ item.sellerPriceDiscountPercentage }}%
                </div>
              }
            </td>

            <td class="px-4 py-4 text-center text-[13px]">
              <div class="font-bold">
                {{
                  item.peoplePrice - (item.peoplePrice * (item.pharmacyPriceDiscountPercentage || 0)) / 100
                    | number: "1.2-2"
                }}
                {{ currency() }}
              </div>
              @if (item.pharmacyPriceDiscountPercentage) {
                <div class="text-[10px] font-bold text-red-500">
                  {{ isArabic() ? "خصم" : "Disc." }} {{ item.pharmacyPriceDiscountPercentage }}%
                </div>
              }
            </td>

            <td class="textTabsColor px-4 py-4 text-center font-bold">{{ item.quantity }}</td>
            <td class="px-6 py-4">
              <div class="flex justify-center gap-3">
                <button (click)="onEdit.emit(i)" class="textTabsColor transition-opacity hover:opacity-70">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button (click)="onRemove.emit(item.id!)" class="textTabsColor transition-opacity hover:opacity-70">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="mt-8 flex items-center justify-end gap-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
    <button
      type="button"
      (click)="showResetDialog.set(true)"
      class="borderTabsColor textTabsColor hover-bg-primary-10 min-w-[160px] rounded-lg border px-8 py-3 font-bold transition">
      <span i18n="@@stock.button.reset">Reset</span>
    </button>

    <button
      type="button"
      (click)="onSubmit.emit()"
      class="bgTabsColor hover-bg-primary-hover min-w-[200px] rounded-lg px-8 py-3 font-bold text-white shadow-md transition">
      <span i18n="@@stock.button.submit">Submit</span>
    </button>
  </div>
</div>

@if (showResetDialog()) {
  <app-confirmation-dialog
    [type]="'reset'"
    [title]="isArabic() ? 'تأكيد المسح' : 'Confirm Reset'"
    [description]="
      isArabic()
        ? 'هل أنت متأكد أنك تريد مسح النموذج؟ سيتم فقدان جميع البيانات المدخلة والعناصر غير المحفوظة في القائمة.'
        : 'Are you sure you want to reset the form? All entered data and unsaved items in the list will be lost.'
    "
    [confirmContent]="isArabic() ? 'مسح' : 'Reset'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onCancel)="showResetDialog.set(false)"
    (onSubmit)="confirmReset()"></app-confirmation-dialog>
}
